import React, { useEffect, useMemo, useRef, useState } from 'react'
import CaseDetails, { isCPTMandatory } from './CaseDetails'
//import NurseNotes from './NurseNotes'
import Summary from './Summary'
import Comments from './Comments'
import {
    ApiDTO_NTSPform,
    ApiDTO_NTSPUI_ElementList,
    initialFormState,
    useGetNTSPCaseMutation,
    useGetNTSPElementsMutation,
    useSaveNTSPCaseMutation,
    useGenerateCaseGuidMutation,
    setTimezone,
    setWasCompletedOnLoad,
    DTO_NTSPCaseNote,
    ProviderNoteGroup,
    NTSPElement,
} from './Ntsp_Slice'
import PatientDetails from './PatientDetails'
import Dialog from './confirmdialog'
import { FieldErrors, set } from 'react-hook-form'
import { formatDateTimeLocal, getTimezoneOffset, tzCodeToIANA, IANAToTzCode } from '../../Utils'
import { time } from 'console'
import UnsavedChangesGuard from './UnsavedChangesGaurd'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment-timezone'
import PatientEducation from './PatientEducation'
import CaseLink from './CaseLink'
import ProcessIssues from './ProcessIssues' //FP-14209 - NTSP Stat Portal - Process Issues Tab Component
import PostMRSTracking from './PostMRSTracking' //FP-14213: Post MRS Tracking Component

declare let window: any
const UnicornApp = window.unicornInstance as any

const isCompletedOrTelephoneOutcome = (etlMatchValue?: string): boolean => {
    const normalizedValue = etlMatchValue?.toLowerCase() || ''
    return normalizedValue === 'completed' || normalizedValue.includes('telephone')
}

// Helper function to open OCV dialogs
const openOCVDialog = (procId: number, key: string | number, name: string, title: string) => {
    if (!window.healthlevelGenericObjectViewer?.openObjectViewDialog) {
        console.error('healthlevelGenericObjectViewer not available')
        return
    }

    const objectContext = {
        Id: procId,
        Name: name,
        Description: name,
        StoredProcParams: `{"key": "${key}"}`,
        Links: {
            GET: [{
                Url: `API/v3/Object/${procId}`,
                Template: null,
                Rel: 'Object',
                ResponseHints: null,
            }],
            POST: [{
                Url: `API/v3/Object/${procId}`,
                Template: `{"key": "${key}"}`,
                Rel: 'Object',
                ResponseHints: null,
            }],
        },
        Warning: 'All OK',
        MessageResults: [],
        title,
    }

    window.healthlevelGenericObjectViewer.openObjectViewDialog(
        document.createElement('span'),
        objectContext,
        'popup',
        window.healthlevelGenericObjectViewer.OCVTYPE.generic
    )
}

export const DarkModeColors = {
    DarkGrey: '#495057',
    DarkerGrey: '#333',
    textColorWhite: '#fff',
    grey: 'grey',
    BlueGreyDark: '#2f3337',
    lightGrey: '#bbbbbb',
    lightGrey1: '#616161',
    DarkBlue: '#305a9d',
    HoverDarkGrey: '#4d4d4d',
    ListItemSelectedGrey: '#747474',
    AdminTasksGrey: '#495057',
    Black: '#000000',
}

export const LightModeColors = {
    grey: 'grey',
    textColorLightBlack: '#ccc',
    textColorBlack: '#000',
    textColorWhite: '#fff',
    lightGrey: '#bbbbbb',
    DarkGrey: '#495057',
    LightBlue: '#62a0de',
    DarkBlue: '#0e4a67',
    Grey2: '#888888',
    LightBlue1: '#6394f6',
    Black: '#000000',
}

export const getReactSelectCustomStyles = (isDarkMode: boolean) => {
    const textColor = isDarkMode ? DarkModeColors.textColorWhite : LightModeColors.textColorBlack
    const greyColor = isDarkMode ? DarkModeColors.grey : LightModeColors.Black
    const placeholderColor = isDarkMode ? DarkModeColors.textColorWhite : LightModeColors.Grey2
    const selectedBg = isDarkMode ? DarkModeColors.ListItemSelectedGrey : LightModeColors.lightGrey
    const focusedBg = isDarkMode ? DarkModeColors.DarkBlue : LightModeColors.LightBlue1
    const baseBg = isDarkMode ? DarkModeColors.AdminTasksGrey : LightModeColors.textColorWhite

    return {
        control: (provided: any, state: any) => ({
            ...provided,
            backgroundColor: isDarkMode ? '#495057' : '#ffffff',
            border: `1px solid ${greyColor}`,
            borderRadius: '5px',
            color: textColor,
            height: '86px',
            minHeight: '86px',
            alignItems: 'center',
            boxShadow: state.isFocused ? 'none' : provided.boxShadow,
            minWidth: '250px',
            maxWidth: '375px',
            width: '250px',
        }),
        input: (base: any) => ({
            ...base,
            color: textColor,
            fontSize: '16px',
            margin: 0,
        }),
        placeholder: (base: any) => ({
            ...base,
            color: placeholderColor,
        }),
        valueContainer: (provided: any) => ({
            ...provided,
            paddingTop: 0,
            paddingBottom: 0,
            marginBottom: 2,
            overflowY: 'auto',
            maxHeight: '80px',
            minHeight: '27px',
            backgroundColor: isDarkMode ? DarkModeColors.AdminTasksGrey : undefined,
        }),
        indicatorsContainer: (provided: any) => ({
            ...provided,
            height: '73px',
        }),
        dropdownIndicator: (provided: any) => ({
            ...provided,
            paddingTop: 0,
            paddingBottom: 0,
            marginTop: '4px',
            color: isDarkMode ? DarkModeColors.textColorWhite : DarkModeColors.lightGrey,
            ':hover': {
                color: isDarkMode ? DarkModeColors.textColorWhite : DarkModeColors.lightGrey,
            },
        }),
        clearIndicator: (provided: any) => ({
            ...provided,
            paddingTop: 0,
            paddingBottom: 0,
            marginTop: '5px',
            color: isDarkMode ? DarkModeColors.textColorWhite : LightModeColors.textColorBlack,
            ':hover': {
                color: isDarkMode ? DarkModeColors.textColorWhite : LightModeColors.textColorBlack,
            },
        }),
        indicatorSeparator: (provided: any) => ({
            ...provided,
            height: '65px',
            backgroundColor: isDarkMode ? DarkModeColors.lightGrey : LightModeColors.grey,
        }),
        menu: (provided: any) => ({
            ...provided,
            paddingTop: 0,
            paddingBottom: 0,
        }),
        menuList: (provided: any) => ({
            ...provided,
            backgroundColor: isDarkMode ? DarkModeColors.AdminTasksGrey : LightModeColors.textColorWhite,
            scrollbarColor: isDarkMode ? `${DarkModeColors.lightGrey} transparent` : undefined,
            '&::-webkit-scrollbar-thumb': {
                background: isDarkMode ? DarkModeColors.lightGrey : LightModeColors.lightGrey,
                borderRadius: '4px',
            },
        }),
        singleValue: (base: any) => ({
            ...base,
            color: textColor,
            borderColor: greyColor,
        }),
        option: (provided: any, state: any) => {
            const { isDisabled, isFocused, isSelected } = state
            const bgColor = isSelected ? selectedBg : isFocused ? focusedBg : baseBg
            const optTextColor = isDisabled
                ? isDarkMode ? DarkModeColors.lightGrey : LightModeColors.DarkGrey
                : textColor

            return {
                ...provided,
                backgroundColor: bgColor,
                color: optTextColor,
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                ':active': { backgroundColor: bgColor },
            }
        },
    }
}


export const DEFAULT_LKW_TIME = '00:01'

export const AcuteServiceKey = 1 // Special key to identify Acute consultant
export const SabacuteServiceKey = 2 // Special key to identify Sabacute consultant
export const teleEEGServiceKey = 3 // Special key to identify TeleEEG consultant
export const Neurohospitalistkey=4; // Special key to identify Neurohospitalist consultant

export const getServiceLineEnum = (
    consultServices: NTSPElement[] | undefined,
    serviceLineKey: number
): number | undefined => {
    if (!consultServices) return undefined;
    const service = consultServices.find((s) => s._key === serviceLineKey);
    return service?.ServiceLineEnum;
};

export const isPatientEducationFollowUp = (
    ntspElements?: ApiDTO_NTSPUI_ElementList,
    fk_FollowUp?: number
): boolean => {
    if (!ntspElements?.FollowUp || fk_FollowUp == null) return false
    const selected = ntspElements.FollowUp.find(f => f._key === Number(fk_FollowUp))
    return selected?.FriendlyName?.trim().toLowerCase() === 'patient education'
}
export const is24HourFollowUp = (
    ntspElements?: ApiDTO_NTSPUI_ElementList,
    fk_FollowUp?: number
): boolean => {
    if (!ntspElements?.FollowUp || fk_FollowUp == null) return false
    const selected = ntspElements.FollowUp.find(f => f._key === Number(fk_FollowUp))
    return selected?.ETLMatchValue?.trim().toLowerCase() === '24 hr acute follow up needed'
}
type NTSPCaseResponse = {
    FormData: { key: string; Value: Object }[]
    Symptoms?: any[]
}

export const isConsultantRequired = (
    form: ApiDTO_NTSPform,
    ntspElements?: ApiDTO_NTSPUI_ElementList
): boolean => {
    const handoffCriteria = ntspElements?.HandOffCriteria?.find(
        (item) => item._key === form.fk_HandOffCriteria
    )

    const isCriteriaMet =
        handoffCriteria?.ETLMatchValue?.toLowerCase().includes('criteria met') &&
        !handoffCriteria?.ETLMatchValue?.toLowerCase().includes('not')
    const isTelephoneConsultRequested = !!form.flag_HandOff2NTSPConsult

    return isCriteriaMet || isTelephoneConsultRequested
}

const PatientDetailsvalidationSchema: { [key: string]: (form: ApiDTO_NTSPform, ntspElements?: ApiDTO_NTSPUI_ElementList) => string } = {
    fk_Facility: (form) =>
        form.fk_Facility && (form.fk_Facility as any) !== '-1' && form.fk_Facility !== -1 ? '' : 'Please select a facility.',
    fk_PatientLocation: (form) =>
        form.fk_PatientLocation && (form.fk_PatientLocation as any) !== '-1' && form.fk_PatientLocation !== -1 ? '' : 'Please select patient location.',
    ts_Consult: (form) => (form.ts_Consult ? '' : 'Please set the consult time.'),
    PatientFirstName: (form) => (form.PatientFirstName ? '' : 'Patient first name required.'),
    PatientLastName: (form) => (form.PatientLastName ? '' : 'Patient last name required.'),
    PatientSSN: (form) => ((!!form.PatientSSN || !!form.FinCenter) ? '' : 'Patient SSN or FIN required.'),
    fk_ConsultService: (form) =>
        form.fk_ConsultService && (form.fk_ConsultService as any) !== '-1' && form.fk_ConsultService !== -1 ? '' : 'Service Line required.',
    fk_Consultant: (form, ntspElements) => {
        if (!isConsultantRequired(form, ntspElements)) {
            return ''
        }

        return form.fk_Consultant && form.fk_Consultant !== -1
            ? ''
            : 'Consultant is required when criteria is met or telephone consultation is requested.'
    },
    ts_LKWDate: (form) => {
        if (!form.ts_LKWDate) return ''
        const lkwDate = moment(form.ts_LKWDate, 'MM/DD/YYYY')
        if (!lkwDate.isValid()) return ''
        const now = moment()
        if (lkwDate.isAfter(now, 'day')) {
            return 'LKW date cannot be in the future'
        }
        return ''
    },
    // ...add more fields as needed
}
const ClinicalvalidationSchema: { [key: string]: (form: any, ntspElements?: ApiDTO_NTSPUI_ElementList) => string } = {

    fk_ConsultService: (form) =>
        form.fk_ConsultService && form.fk_ConsultService !== '-1' && form.fk_ConsultService !== -1 ? '' : 'Service Line required.',
     fk_FollowupNeeded: (form, ntspElements) => {
        //FP-14557 Child follow-up cases do not expose the "No Follow Up Needed" control.
        if (form.fk_FollowUp !== -1) return ''

        // Check if facility supports both Acute and SubAcute
        const facilitySupportsSubAcute = ntspElements?.Facilities?.some(
            (facility: any) => facility._key === form.fk_Facility && facility.SiteStatus?.toLowerCase() === 'acute and subacute'
        );
        return (
            form.fk_FollowupNeeded !== 0 && 
            (!form.fk_FollowUps?.length || form.fk_FollowUps[0] === -1) &&
            ntspElements?.Outcome?.find((outcome) => outcome._key === form.fk_Outcome && outcome.IsAllowFollowUp==true) && 
            form.fk_ConsultService !== teleEEGServiceKey &&
            facilitySupportsSubAcute
        ) ? 'You must either create a follow up case or check No Follow Up Needed before marking complete' : '';
    },
    fk_CPTCode: () => '',
    fk_CPTCodes: (form, ntspElements) => {
        const wasCompletedOnLoad = Boolean((form as any)._wasCompletedOnLoad)
        const providerNotes = (form as any)._providerNotes
        return isCPTMandatory(form, ntspElements, wasCompletedOnLoad, providerNotes) && (!form.fk_CPTCodes || !Array.isArray(form.fk_CPTCodes) || form.fk_CPTCodes.length === 0 || form.fk_CPTCodes.every((code: number) => code === -1))
            ? 'CPT Code is required.'
            : ''
    },
    NewNote: (form) =>
        ((Boolean(form.ExamCompleted) || (form.fk_CPTCodes && Array.isArray(form.fk_CPTCodes) && form.fk_CPTCodes.length > 0 && form.fk_CPTCodes.some((code: number) => code !== -1))) && (!form.NewNote || form.NewNote.trim() === ''))
            ? (Boolean(form.ExamCompleted)
                ? 'New Provider Note is required when Exam Completed is selected.'
                : 'New Provider Note is required when CPT Code is selected.')
            : '',
    ts_Thrombolytic: (form) =>
         form.fk_ConsultService === AcuteServiceKey &&
        form.fk_Thrombolytic !== -1 &&
        (!form.ts_Thrombolytic || form.ts_Thrombolytic.toString().trim() === '')
            ? 'Thrombolytic given time is required.'
            : '',
    // ...add more fields as needed
}

//FP-14209 Validation schema for Process Issues tab - all fields mandatory
export const ProcessIssuesValidationSchema: { [key: string]: (form: any, ntspElements?: ApiDTO_NTSPUI_ElementList) => string } = {
    fk_ImpactOfIssue: (form) =>
        form.fk_ImpactOfIssue && form.fk_ImpactOfIssue !== -1 && form.fk_ImpactOfIssue !== '-1'
            ? ''
            : 'Please select impact of the issue.',
    fk_TypeOfIssue: (form) =>
        form.fk_TypeOfIssue && form.fk_TypeOfIssue !== -1 && form.fk_TypeOfIssue !== '-1'
            ? ''
            : 'Please select type of issue.',
    fk_IssueStatus: (form) =>
        form.fk_IssueStatus && form.fk_IssueStatus !== -1 && form.fk_IssueStatus !== '-1'
            ? ''
            : 'Please select issue status.',
    TicketNumber: (form) =>
        form.TicketNumber && form.TicketNumber.trim() !== ''
            ? ''
            : 'Please enter ticket number.',
    IssueDescription: (form) =>
        form.IssueDescription && form.IssueDescription.trim() !== ''
            ? ''
            : 'Please describe the issue.',
}

//FP-14213 Validation schema for Post MRS Tracking tab
const PostMRSValidationSchema: { [key: string]: (form: any, ntspElements?: ApiDTO_NTSPUI_ElementList) => string } = {
    ts_Discharge: (form) => form.ts_Discharge ? '' : 'Please set the date of discharge.',
    CurrentAttempt: (form) => form['ts_Attempt' + form.CurrentAttempt] ? '' : 'Please check the current call attempt.',
    flag_IsPatientDeceased: (form) => (!form.flag_CallSuccessful || form.flag_IsPatientDeceased === true || form.flag_IsPatientDeceased === false) ? '' : 'Please select Yes or No.',
    flag_Q1: (form) => (form.flag_IsPatientDeceased !== false || form.flag_Q1 === true || form.flag_Q1 === false) ? '' : 'Please select Yes or No.',
    flag_Q2: (form) => (form.flag_Q1 !== true || form.flag_Q2 === true || form.flag_Q2 === false) ? '' : 'Please select Yes or No.',
    flag_Q3: (form) => (form.flag_Q1 !== false || form.flag_Q3 === true || form.flag_Q3 === false) ? '' : 'Please select Yes or No.',
    flag_Q4: (form) => (form.flag_Q2 !== true || form.flag_Q4 === true || form.flag_Q4 === false) ? '' : 'Please select Yes or No.',
    flag_Q5: (form) => (form.flag_Q3 !== false || form.flag_Q5 === true || form.flag_Q5 === false) ? '' : 'Please select Yes or No.',
};

// Combine Patient Details and Clinical schemas to validate across all tabs
const FullValidationSchema: { [key: string]: (form: any, ntspElements?: ApiDTO_NTSPUI_ElementList) => string } = {
    ...PatientDetailsvalidationSchema,
    ...ClinicalvalidationSchema,
}
export function convertEasternToLocal(
    dateStrInEastern: string | Date,
    tzCode?: string
): string | null {
    if (typeof dateStrInEastern !== 'string') {
        // If the input is a string, ensure it is in a valid format
        dateStrInEastern = dateStrInEastern.toString()
    }
    if (tzCode === 'America/New_York') {
        // If the time zone is already Eastern Time, we can return the date as is
        // return new Date(dateStrInEastern);
        return dateStrInEastern
    }
    if (!dateStrInEastern) return null
    const date = new Date(dateStrInEastern)
    const newYorkOffset = getTimezoneOffset('America/New_York', date)
    const utcTime = date.getTime() - newYorkOffset
    const localTime = new Date(utcTime + getTimezoneOffset(tzCode, date))
    return formatDateTimeLocal(localTime)
    // const utcDateTime = new Date(utcTime);
    // return formatDateTimeLocal(utcDateTime);
}

export function validateForm(form: any, schema: { [key: string]: (value: any, ntspElements?: ApiDTO_NTSPUI_ElementList) => string }, ntspElements?: ApiDTO_NTSPUI_ElementList) {
    const errors: { [key: string]: string } = {}
    Object.keys(schema).forEach((field) => {
        const error = schema[field](form, ntspElements)
        errors[field] = error
    })
    return errors
}
export const getAge = (dob: string): number => {
    const birthDate = new Date(dob)
    const now = new Date()

    if (birthDate > now) return 0 // prevent negative age

    const age = Math.floor((now.getTime() - birthDate.getTime()) / 31557600000) // avg year in ms
    return age
}

/** FP-14007 
 * Filters out elements with _key === -1 from NTSP element arrays
 * These are placeholder "Unknown" entries from the backend that should not be displayed in UI
 */
export function filterUnknownElements(elements: ApiDTO_NTSPUI_ElementList): ApiDTO_NTSPUI_ElementList {
    return {
        ...elements,
        Facilities: elements.Facilities?.filter(item => item._key !== -1) || [],
        PatientLocations: elements.PatientLocations?.filter(item => item._key !== -1) || [],
        ConsultServices: elements.ConsultServices?.filter(item => item._key !== -1) || [],
        Diagnosis: elements.Diagnosis?.filter(item => item._key !== -1) || [],
        Thrombolytic: elements.Thrombolytic?.filter(item => item._key !== -1) || [],
        Sex: elements.Sex?.filter(item => item._key !== -1) || [],
        CallerPosition: elements.CallerPosition?.filter(item => item._key !== -1) || [],
        Consultants: elements.Consultants?.filter(item => item._key !== -1) || [],
        HandOffCriteria: elements.HandOffCriteria?.filter(item => item._key !== -1) || [],
        FollowUp: elements.FollowUp?.filter(item => item._key !== -1) || [],
        Symptoms: elements.Symptoms?.filter(item => item._key !== -1) || [],
        EEGType: elements.EEGType?.filter(item => item._key !== -1) || [],
        PerformedBy: elements.PerformedBy?.filter(item => item._key !== -1) || [],
        Contact: elements.Contact?.filter(item => item._key !== -1) || [],
        ConsultantTypes: elements.ConsultantTypes?.filter(item => item._key !== -1) || [],
        ASDGiven: elements.ASDGiven?.filter(item => item._key !== -1) || [],
        Consultants24Hr: elements.Consultants24Hr?.filter(item => item._key !== -1) || [],
        Impacts: elements.Impacts?.filter(item => item._key !== -1) || [], //FP-14209 - Process Issues Tab
        TypeOfIssue: elements.TypeOfIssue?.filter(item => item._key !== -1) || [], //FP-14209 - Process Issues Tab
        IssueStatus: elements.IssueStatus?.filter(item => item._key !== -1) || [], //FP-14209 - Process Issues Tab
        CPTCodes: elements.CPTCodes?.filter(item => item._key !== -1) || []
    }
}

export function getNowInFacilityTimezone(
    facilityKey: number,
    NTSPElements: any,
    tzCodeToIANA: (tz: string) => string
): string {
    const selectedFacility = NTSPElements?.Facilities?.find((f: any) => f._key === facilityKey)
    const ianaTz = selectedFacility?.TZCode ? tzCodeToIANA(selectedFacility.TZCode) : undefined
    const now = ianaTz ? moment.tz(new Date(), ianaTz) : moment(new Date())
    return now.format('YYYY-MM-DDTHH:mm')
}

export function getNowInFacilityTimezonePrecise(
    facilityKey: number,
    NTSPElements: any,
    tzCodeToIANA: (tz: string) => string
): string {
    const selectedFacility = NTSPElements?.Facilities?.find((f: any) => f._key === facilityKey)
    const ianaTz = selectedFacility?.TZCode ? tzCodeToIANA(selectedFacility.TZCode) : undefined
    const now = ianaTz ? moment.tz(new Date(), ianaTz) : moment(new Date())
    return now.format('YYYY-MM-DDTHH:mm:ss.SSS')
}

const normalizeToMinute = (value?: string | null): string => {
    if (!value) return ''
    const normalized = moment(value)
    return normalized.isValid() ? normalized.format('YYYY-MM-DDTHH:mm') : String(value)
}



// export function splitNotesByType(
//     notes: DTO_NTSPCaseNote[] | ProviderNoteGroup[] | undefined
// ) {
//     if (!notes) {
//         return { providerNotes: [], nurseNotes: [] };
//     }
//     if (
//         Array.isArray(notes) &&
//         notes.length > 0 &&
//         (notes[0] as ProviderNoteGroup).ProviderCaseNotes !== undefined
//     ) {
//         const providerNotes: ProviderNoteGroup[] = [];
//         const nurseNotes: DTO_NTSPCaseNote[] = [];

//         (notes as ProviderNoteGroup[]).forEach(group => {
//             if (
//                 group.ProviderCaseNotes &&
//                 group.ProviderCaseNotes.some(n => n.NoteType === 'ProviderNote')
//             ) {
//                 providerNotes.push(group);
//             }
//             if (group.ProviderCaseNotes) {
//                 nurseNotes.push(
//                     ...group.ProviderCaseNotes.filter(n => n.NoteType === 'NurseNote')
//                 );
//             }
//         });

//         return { providerNotes, nurseNotes };
//     }
//     return {
//         providerNotes: (notes as ProviderNoteGroup[]).filter(n => n.NoteType === 'ProviderNote') || [],
//         nurseNotes: (notes as DTO_NTSPCaseNote[]).filter(n => n.NoteType === 'NurseNote') || [],
//     };
//}


export type TabType =
    | 'PatientDetails'
    | 'CaseDetails'
    | 'Summary'
    | 'Comments'
    | 'PatientEducation'
    | 'CaseLink'
    | 'ProcessIssues'  //FP-14209 - NTSP Stat Portal - Process Issues Tab Component
    | 'PostMRSTracking' //FP-14213: Post MRS Tracking Component

const NTSP_StatPortal: React.FC<any> = (props) => {
    const [caseId, setCaseId] = useState<string | undefined>(props.caseId || undefined)
    const [FormGuid, setFormGuid] = useState<string>('')
    const [reload, setReload] = useState<boolean>(false) //hacky, should revisit later
    const [activeTab, setActiveTab] = useState<TabType>('PatientDetails')
    const [ntspElements, setNtspElements] = useState<ApiDTO_NTSPUI_ElementList>()
    const [isLoadingNTSPElements, setIsLoadingNTSPElements] = useState<boolean>(true)
    const [GetNTSPElements] = useGetNTSPElementsMutation()
    const [GetNTSPCase] = useGetNTSPCaseMutation()
    const [SaveNTSPCase, { error: savingError, isLoading: configLoading }] =
        useSaveNTSPCaseMutation()
    const [GenerateCaseGuid] = useGenerateCaseGuidMutation()
    const [form, setForm] = useState(initialFormState)
    const [tempId, setTempId] = useState<string>('')
    const [isSaved, setIsSaved] = useState<boolean>(false)
    const savedDiagnosisTime = useRef<string>('')

    const providerNotes = useMemo(() => form.ProviderNotes, [form.ProviderNotes]);

    const nurseNotes = useMemo(() => form.Notes, [form.Notes]);

    const initialFormRef = useRef(form)
    const [isCustomerSite] = useState<boolean>(UnicornApp.checkUserPrivileges("NTSPCustomer"))

    const [dialogOpen, setDialogOpen] = useState(false)
    const [dialogType, setDialogType] = useState<'clear' | 'tab' | 'load' | null>(null)
    const [pendingTab, setPendingTab] = useState<TabType | null>(null)
    const formRef = useRef<HTMLSpanElement>(null)
    const dispatch = useDispatch()
    const [tzCode, setTimezoneState] = useState<string>('')
    const timeZone = useSelector((state: any) => state.ntspSlice.timezone)
    const [selectedSymptoms, setSelectedSymptoms] = useState<{
        [s: string]: { label: string; value: string }[]
    }>({})
    // const validationMessages: { [key: string]: string } = {
    //     fk_Facility: "Please select a facility.",
    //     fk_PatientLocation: "Please select patient location.",
    //     ts_Consult: "Please set the consult time.",
    //     PatientFirstName: "Patient first name required.",
    //     PatientLastName: "Patient last name required.",
    //     fk_ConsultService: "Service Line required.",
    // };
    const [errors, setErrors] = useState<{ [s: string]: string }>({})
    const [isdirty, setIsDirty] = useState<boolean>(false)
    const [facilityTime, setFacilityTime] = useState<string>('')

    const checkDirty = () => {
        return JSON.stringify(form) !== JSON.stringify(initialFormRef.current)
    }

    useEffect(() => {
        setIsDirty(checkDirty())
    }, [form])

     useEffect(() => {
        setForm((prev: ApiDTO_NTSPform) => ({
            ...prev,
            Symptoms: Object.keys(selectedSymptoms)?.map(typeKey=>selectedSymptoms[typeKey]?.map((symptom) => parseInt(symptom.value))).flat() || []
        }))
    }, [selectedSymptoms])
    // Do not clear validation errors on tab switch; preserve them so
    // users can see and fix errors across tabs.

    // const handleClearWithPrompt = () => {
    // if (checkDirty()) {
    //     setDialogType("clear");
    //     setDialogOpen(true);
    // } else {
    // handleClear();
    // }
    // };
    
    const handleTabSwitch = (tab: TabType) => {
        if (!isCustomerSite){
            if (checkDirty()) {
                setDialogType('tab')
                setPendingTab(tab)
                setDialogOpen(true)
            } else {
                setActiveTab?.(tab)
            }
        }
    }

    const handleDialogCancel = () => {
        setDialogOpen(false)
        setDialogType(null)
        setPendingTab(null)
    }

    const handleDialogConfirm = () => {
        setDialogOpen(false)
        if (dialogType === 'load') {
            // If trying to reload the same case, force a reload by toggling reload state
            if (tempId === caseId) {
                setReload(!reload)
            } else {
                setCaseId(tempId)
            }
            setTempId('')
            setIsSaved(true)
            formRef.current?.scrollIntoView({ behavior: 'smooth' })
        } else if (dialogType === 'clear') {
            handleClear()
            setIsSaved(false)
        } else if (dialogType === 'tab' && pendingTab) {
            setActiveTab?.(pendingTab)
        }
        setDialogType(null)
        setPendingTab(null)
    }


    useEffect(() => {
        window.loadNTSPCase = (caseId: string, formGuid: string, tabno?: number) => {
            setTempId('')
            setTempId(caseId)
            setFormGuid(formGuid)   
            // If tabno is provided, set the active tab accordingly
            if (tabno !== undefined && !isCustomerSite) {
                switch (tabno) {
                    case 1:
                        setActiveTab('PatientDetails')
                        break
                    case 2:
                        setActiveTab('CaseDetails')
                        break
                    case 3:
                        setActiveTab('Comments')
                        break
                    case 4:
                        setActiveTab('Summary')
                        break
                    case 5:
                        setActiveTab('PatientEducation')
                        break
                    case 6:
                        setActiveTab('ProcessIssues') //FP-14209 - NTSP Stat Portal - Process Issues Tab Component
                        break
                    default:
                        setActiveTab('CaseDetails')
                }
            
            } else if (!isCustomerSite) {
                setActiveTab('PatientDetails')
            }
        }
        setIsLoadingNTSPElements(true)
        GetNTSPElements()
            .unwrap()
            .then((response) => {
                if (response !== null) {
                    //FP-14007 - Filter out Unknown elements (_key === -1) before setting state
                    const filteredResponse = filterUnknownElements(response)
                    setNtspElements(filteredResponse)
                }
                setIsLoadingNTSPElements(false)
            })
            .catch((error) => {
                console.error('Error:', error)
                setIsLoadingNTSPElements(false)
            })
    }, [])

    //check for unsaved changes before opening a case (same or different)
    useEffect(() => {
        if (!!tempId && checkDirty()) {
            setDialogType('load')
            setDialogOpen(true)
        } else if (!!tempId) {
            setCaseId(tempId)
            setIsSaved(true)
            formRef.current?.scrollIntoView({ behavior: 'smooth' })
        }
    }, [tempId])

    useEffect(() => {
        if (isSaved && caseId != null && caseId !== '') {
            setErrors({})
            GetNTSPCase({ caseId, FormGuid })
                .unwrap()
                .then((response: NTSPCaseResponse) => {
                    if (response !== null) {
                        // Convert response.FormData (Array<{ key: string, Value: any }>) to ApiDTO_NTSPform
                        const formDataObj: ApiDTO_NTSPform = Array.isArray(response.FormData)
                            ? response.FormData.reduce((acc: any, item: any) => {
                                  acc[item.key] = item.Value
                                  return acc
                              }, {} as ApiDTO_NTSPform)
                            : {}
                        if (!isCustomerSite && isPatientEducationFollowUp(ntspElements, formDataObj.fk_FollowUp) && activeTab !== 'PatientEducation') {
                            setActiveTab('PatientEducation')
                        }
                        if (formDataObj.tzCode) {
                            setTimezoneState(formDataObj.tzCode)
                            dispatch(setTimezone(formDataObj.tzCode))
                        } else console.log('Timezone not set for this case.')

                        if (formDataObj.PatientAge === null || formDataObj.PatientAge === 0) {
                            formDataObj.PatientAge = form.PatientDOB
                                ? getAge(form.PatientDOB.toString())
                                : 0
                        }

                        formDataObj.Symptoms = response.Symptoms ?? []
                        // convert all timezones to local time before displaying
                        formDataObj.ts_Consult = formDataObj.ts_Consult
                            ? convertEasternToLocal(
                                  formDataObj.ts_Consult.toString(),
                                  formDataObj.tzCode?.toString()
                              )
                            : ''
                        formDataObj.ts_Call = formDataObj.ts_Call
                            ? convertEasternToLocal(
                                  formDataObj.ts_Call.toString(),
                                  formDataObj.tzCode?.toString()
                              )
                            : ''
                        formDataObj.ts_HandOff = formDataObj.ts_HandOff
                            ? convertEasternToLocal(
                                  formDataObj.ts_HandOff.toString(),
                                  formDataObj.tzCode?.toString()
                              )
                            : ''
                        formDataObj.ts_LKW = formDataObj.ts_LKW
                            ? convertEasternToLocal(
                                  formDataObj.ts_LKW.toString(),
                                  formDataObj.tzCode?.toString()
                              ) ?? ''
                            : ''
                        formDataObj.ts_DiagnosisTime = formDataObj.ts_DiagnosisTime
                            ? convertEasternToLocal(
                                formDataObj.ts_DiagnosisTime.toString(),
                                formDataObj.tzCode?.toString()
                            ) ?? ''
                            : ''
                        formDataObj.ts_EducationTime = formDataObj.ts_EducationTime
                            ? convertEasternToLocal(
                                formDataObj.ts_EducationTime.toString(),
                                formDataObj.tzCode?.toString()
                            ) ?? ''
                            : ''
                        formDataObj.ts_Thrombolytic = formDataObj.ts_Thrombolytic
                            ? convertEasternToLocal(
                                  formDataObj.ts_Thrombolytic.toString(),
                                  formDataObj.tzCode?.toString()
                              )
                            : ''
                        if (formDataObj.ts_LKW !== null && formDataObj.ts_LKW !== '') {
                            const [datePart, timePart] = formDataObj.ts_LKW.split('T')
                            if (datePart) {
                                const [yyyy, mm, dd] = datePart.split('-')
                                formDataObj.ts_LKWDate = `${mm}/${dd}/${yyyy}`
                            } else {
                                formDataObj.ts_LKWDate = ''
                            }

                            if (timePart) {
                                const timeHHmm = timePart.slice(0, 5)
                                formDataObj.ts_LKWTime = timeHHmm === DEFAULT_LKW_TIME ? '' : timeHHmm
                            } else {
                                formDataObj.ts_LKWTime = ''
                            }
                            
                        } else {
                            formDataObj.ts_LKWDate = ''
                            formDataObj.ts_LKWTime = ''
                        }
                        formDataObj.ts_EDArrivalTime = formDataObj.ts_EDArrivalTime
                            ? convertEasternToLocal(
                                formDataObj.ts_EDArrivalTime.toString(),
                                formDataObj.tzCode?.toString()
                            )
                            : ''
                        // split ED Arrival into date and time
                        if (formDataObj.ts_EDArrivalTime !== null && formDataObj.ts_EDArrivalTime !== '') {
                            const [datePart, timePart] = formDataObj.ts_EDArrivalTime.split('T')
                            if (datePart) {
                                const [yyyy, mm, dd] = datePart.split('-')
                                formDataObj.ts_EDArrivalDateOnly = `${mm}/${dd}/${yyyy}`
                            } else {
                                formDataObj.ts_EDArrivalDateOnly = ''
                            }

                            if (timePart) {
                                const timeHHmm = timePart.slice(0, 5)
                                formDataObj.ts_EDArrivalTimeOnly = timeHHmm === DEFAULT_LKW_TIME ? '' : timeHHmm
                            } else {
                                formDataObj.ts_EDArrivalTimeOnly = ''
                            }
                            
                        } else {
                            formDataObj.ts_EDArrivalDateOnly = ''
                            formDataObj.ts_EDArrivalTimeOnly = ''
                        }
                        formDataObj.ts_WakeUpStroke = formDataObj.ts_WakeUpStroke
                            ? convertEasternToLocal(
                                formDataObj.ts_WakeUpStroke.toString(),
                                formDataObj.tzCode?.toString()
                            )
                            : ''

                        // FP-14213: Convert call attempt timestamps to local time
                        formDataObj.ts_Attempt1 = formDataObj.ts_Attempt1
                            ? convertEasternToLocal(
                                formDataObj.ts_Attempt1.toString(),
                                formDataObj.tzCode?.toString()
                            )
                            : ''
                        formDataObj.ts_Attempt2 = formDataObj.ts_Attempt2
                            ? convertEasternToLocal(
                                formDataObj.ts_Attempt2.toString(),
                                formDataObj.tzCode?.toString()
                            )
                            : ''
                        formDataObj.ts_Attempt3 = formDataObj.ts_Attempt3
                            ? convertEasternToLocal(
                                formDataObj.ts_Attempt3.toString(),
                                formDataObj.tzCode?.toString()
                            )
                            : ''
                         formDataObj.ts_RowCreated = formDataObj.ts_RowCreated
                            ? convertEasternToLocal(
                                  formDataObj.ts_RowCreated.toString(),
                                  formDataObj.tzCode?.toString()
                              )
                            : ''
                         formDataObj.ts_RowUpdated = formDataObj.ts_RowUpdated
                            ? convertEasternToLocal(
                                  formDataObj.ts_RowUpdated.toString(),
                                  formDataObj.tzCode?.toString()
                              )
                            : ''

                        if (formDataObj.ts_WakeUpStroke !== null && formDataObj.ts_WakeUpStroke !== '') {
                            const [datePart, timePart] = formDataObj.ts_WakeUpStroke.split('T')
                            if (datePart) {
                                const [yyyy, mm, dd] = datePart.split('-')
                                formDataObj.ts_WakeUpStrokeDate = `${mm}/${dd}/${yyyy}`
                            } else {
                                formDataObj.ts_WakeUpStrokeDate = ''
                            }

                            if (timePart) {
                                const timeHHmm = timePart.slice(0, 5)
                                formDataObj.ts_WakeUpStrokeTime = timeHHmm === DEFAULT_LKW_TIME ? '' : timeHHmm
                            } else {
                                formDataObj.ts_WakeUpStrokeTime = ''
                            }
                        } else {
                            formDataObj.ts_WakeUpStrokeDate = ''
                            formDataObj.ts_WakeUpStrokeTime = ''
                        }
                        if(formDataObj.flag_DiagnosisDiscussed)
                        {
                            savedDiagnosisTime.current = normalizeToMinute(formDataObj.ts_DiagnosisTime || '');
                        }
                        Object.keys(formDataObj).forEach((key) => {
                            if ((formDataObj as any)[key] === null) {
                                ;(formDataObj as any)[key] =
                                    initialFormState[key as keyof ApiDTO_NTSPform]
                            }
                        })

                        const loadedOutcome = ntspElements?.Outcome?.find(
                            (outcome) => outcome._key === formDataObj.fk_Outcome
                        )
                        const wasCompletedOnLoad = isCompletedOrTelephoneOutcome(
                            loadedOutcome?.ETLMatchValue
                        )
                        dispatch(setWasCompletedOnLoad(wasCompletedOnLoad))

                        const loadedFormState = {
                            ...formDataObj,
                            fk_CPTCodes: [], // Always default to unselected
                            _wasCompletedOnLoad: wasCompletedOnLoad,
                        } as any
                        
                        
                        // Ensure fk_FollowUps is properly initialized
                        if (!loadedFormState.fk_FollowUps || 
                            (Array.isArray(loadedFormState.fk_FollowUps) && loadedFormState.fk_FollowUps.length === 0)) {
                            loadedFormState.fk_FollowUps = [-1]
                        }
                        
                        setForm(loadedFormState)
                        initialFormRef.current = loadedFormState // Update initial form state when changing case Id

                        // setForm(prev => ({
                        //     ...prev,
                        //     ...formDataObj,
                        //     StaffFullName: [formDataObj.StaffFirstName, formDataObj.StaffLastName].filter(Boolean).join(" "),
                        // }));

                        // TODO handle initial symptom selection
                        if (Array.isArray(response.Symptoms)) {
                            // const befastSymptoms: number[] = [];
                            // const largeVesselSymptoms: number[] = [];
                            // response.Symptoms.forEach((symptom: any) => {
                            //     if (symptom.fk_SymptomType === 1) {
                            //         befastSymptoms.push(symptom.fk_Symptom);
                            //     } else if (symptom.fk_SymptomType === 2) {
                            //         largeVesselSymptoms.push(symptom.fk_Symptom);
                            //     }
                            // });

                            // setForm(prev => ({
                            //     ...prev,
                            //     BefastSymptoms: befastSymptoms,
                            //     LargeVesselSymptoms: largeVesselSymptoms,
                            // }));
                            initialFormRef.current = {
                                ...loadedFormState,
                                // TODO
                                // BefastSymptoms: befastSymptoms,
                                // LargeVesselSymptoms: largeVesselSymptoms,
                            }
                        }
                        //if (activeTab === 'PatientDetails') setActiveTab('NurseNotes')
                        //setFormActive(true);
                    }
                })
                .catch((error) => {
                    // when api is forbidden we do not get the response instead it goes to catch block
                    if (error.status === 403) {
                        UnicornApp.toastr('error', 'You do not have permission to view the case.')
                    } else {
                        UnicornApp.toastr('error', 'An unexpected error occurred.')
                    }
                    setForm(initialFormState)
                    dispatch(setWasCompletedOnLoad(false))
                    setCaseId(undefined)
                    setActiveTab('PatientDetails')
                })
        }
    }, [caseId, reload])

    const newCase = async () => {
        setErrors({})
        GenerateCaseGuid()
            .unwrap()
            .then((response) => {
                if (response?.CaseId === null || response?.CaseId === '') {
                    UnicornApp.toastr(
                        'error',
                        'Creating Case Failed: ' + 'Invalid Case Id returned from server.'
                    )
                    return
                }
                if (response !== null) {
                    if (response?.CaseId !== '') {
                        const tempFormState = isCustomerSite ? {...initialFormState, fk_Outcome:-1} : initialFormState
                        dispatch(setWasCompletedOnLoad(false))
                        setForm({
                            ...tempFormState,
                            CaseId: response?.CaseId,
                            _wasCompletedOnLoad: false,
                            //ts_Consult:formatDateTimeLocal(new Date()),
                            //ts_HandOff:formatDateTimeLocal(new Date())
                        } as any)
                        initialFormRef.current = {
                            ...initialFormState,
                            CaseId: response?.CaseId,
                            _wasCompletedOnLoad: false,
                            //ts_Consult:formatDateTimeLocal(new Date()),
                            //ts_HandOff:formatDateTimeLocal(new Date())
                        } as any
                        // setCaseId(response?.CaseId);
                        setActiveTab('PatientDetails')
                    }
                }
            })
            .catch((error) => {
                console.error('Error:', error)
            })
    }

    function createNote({
        caseId,
        userId,
        userName,
        noteText,
        tzCode,
        noteType,
        ExamCompleted,
        fk_CPTCodes
    }: {
        caseId: string,
        userId: number,
        userName: string,
        noteText: string,
        tzCode: string,
        noteType: 'ProviderNote' | 'NurseNote',
        ExamCompleted: boolean,
        fk_CPTCodes: number[]
    }): DTO_NTSPCaseNote {
        return {
            Id: -1,
            CaseId: caseId,
            ts_CreationDateTime: getNowInFacilityTimezonePrecise(form.fk_Facility, ntspElements, tzCodeToIANA),
            PostedByUserId: userId,
            PostedByUserFullName: userName,
            Note: noteText, 
            tzCode: tzCode,
            NoteType: noteType,
            ExamCompleted: ExamCompleted,
            fk_CPTCodes: fk_CPTCodes
        };
    }

    function addNoteToGroups(
    note: DTO_NTSPCaseNote,
    existingGroups: ProviderNoteGroup[],
    currentCaseId: string,
    fk_ConsultService: number,
    fk_FollowUp: number,
    parentCaseId: string | null
): ProviderNoteGroup[] {
    if (note.NoteType !== 'ProviderNote') {
        return existingGroups; // no action for other types
    }
    let group = existingGroups.find(g => g.CaseId === currentCaseId);

    if (!group) {
        group = {
            _Id: -1,
            CaseId: currentCaseId,
            ParentCaseId: parentCaseId,
            fk_ConsultService,
            fk_FollowUp,
            ProviderCaseNotes: [],
        };
        existingGroups=[...existingGroups, group]; // create a new array to avoid mutating state elsewhere
    }

    const isDuplicate = group.ProviderCaseNotes.some(
        existing =>
            existing.Note.trim() === note.Note.trim() &&
            existing.PostedByUserId === note.PostedByUserId &&
            existing.ts_CreationDateTime === note.ts_CreationDateTime
    );

    if (!isDuplicate) {
        const tempGroups = existingGroups.map(g => {
            if (g.CaseId === currentCaseId) {
                return { ...g, ProviderCaseNotes: [...g.ProviderCaseNotes, note] };
            }
            return g;
        });
        return tempGroups;
    }

    return existingGroups;
}

    //Return just the date
    function formatDateNTSP(date: string): string | null {
        if (!date) return null
        const match = date.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
        if (!match) return null
        const [, mm, dd, yyyy] = match
        const isoDate = `${yyyy}-${mm}-${dd}`
        return `${isoDate}`
    }

    //Return the combined date and time for LKW
    const getLKWTime = () => {
        if (form.ts_LKWDate && form.ts_LKWTime) {
            return formatDateTimeLocal(formatDateNTSP(form.ts_LKWDate)+"T"+form.ts_LKWTime)
        } else if (!!form.ts_LKWDate) {
            return formatDateTimeLocal(formatDateNTSP(form.ts_LKWDate)+"T"+DEFAULT_LKW_TIME)
        } else if (!!form.ts_LKWTime) {
            return form.ts_LKWTime
        }else {
            return ""
        }
    }

        //Return the combined date and time for ED Arrival
    const getEDArrivlaTime = () => {
        if (form.ts_EDArrivalDateOnly && form.ts_EDArrivalTimeOnly) {
            return formatDateTimeLocal(formatDateNTSP(form.ts_EDArrivalDateOnly)+"T"+form.ts_EDArrivalTimeOnly)
        } else if (!!form.ts_EDArrivalDateOnly) {
            return formatDateTimeLocal(formatDateNTSP(form.ts_EDArrivalDateOnly)+"T"+DEFAULT_LKW_TIME)
        } else if (!!form.ts_EDArrivalTimeOnly) {
            return form.ts_EDArrivalTimeOnly
        }else {
            return ""
        }
    }

    function wakeUpStrokeDateFormat(date: string): string | null {
        if (!date) return null
        const match = date.match(/^(\d{2})\/(\d{2})\/(\d{4})$/)
        if (!match) return null
        const [, mm, dd, yyyy] = match
        const isoDate = `${yyyy}-${mm}-${dd}`
        return `${isoDate}`
    }

    const getWakeUpStrokeTime = () => {
        if (form.ts_WakeUpStrokeDate && form.ts_WakeUpStrokeTime) {
            return formatDateTimeLocal(wakeUpStrokeDateFormat(form.ts_WakeUpStrokeDate)+"T"+form.ts_WakeUpStrokeTime)
        } else if (!!form.ts_WakeUpStrokeDate) {
            return formatDateTimeLocal(wakeUpStrokeDateFormat(form.ts_WakeUpStrokeDate)+"T"+DEFAULT_LKW_TIME)
        } else if (!!form.ts_WakeUpStrokeTime) {
            return form.ts_WakeUpStrokeTime
        } else {
            return ""
        }
    }

    // close is true if we are saving the form after clicking on close button
    const handleSave = async (close: boolean = false, formOverride?: ApiDTO_NTSPform) => { //FP-14292 - Added optional formOverride parameter to allow saving with modified form data without changing the form state

        const userId = UnicornApp.globals?.me.get('id') || -1;
        const userName = UnicornApp.globals?.me.get('AccountInfo')?.name || '';
        const sourceForm = formOverride ?? form  //FP-14292 - Use formOverride if provided, otherwise use current form state. This allows us to save modified data
        // Only include keys present in initialFormState (the DTO)
        const filteredForm: ApiDTO_NTSPform = Object.keys(initialFormState).reduce((acc, key) => {
            ;(acc as any)[key] = sourceForm[key as keyof typeof sourceForm]
            return acc
        }, {} as ApiDTO_NTSPform)

        // Convert form to List<Tuple<key, Value>>
        let combinedForm = {
            ...filteredForm,
            fk_UpdatedBy: userId, 
            fk_CreatedBy:
                filteredForm.fk_CreatedBy == -1
                    ? userId
                    : filteredForm.fk_CreatedBy,
            // convert time into est timezone
            ts_LKW:
                (filteredForm.ts_LKWDate || filteredForm.ts_LKWTime) && !filteredForm.flag_UnknownLKW
                    ? getLKWTime()
                    : null,
            ts_EDArrivalTime:
                (filteredForm.ts_EDArrivalDateOnly || filteredForm.ts_EDArrivalTimeOnly)
                    ? getEDArrivlaTime()
                    : null,
            ts_WakeUpStroke:
                (filteredForm.ts_WakeUpStrokeDate || filteredForm.ts_WakeUpStrokeTime)
                    ? getWakeUpStrokeTime()
                    : null,
            fk_FollowUps: filteredForm.fk_FollowUps, // if user selects followup and closes the form.
            fk_FollowUp: filteredForm.fk_FollowUp,
            ts_Consult: filteredForm.ts_Consult
                ? formatDateTimeLocal(new Date(filteredForm.ts_Consult))
                : null,
            ts_Call: filteredForm.ts_Call
                ? formatDateTimeLocal(new Date(filteredForm.ts_Call))
                : null,
            ts_HandOff: filteredForm.ts_HandOff
                ? formatDateTimeLocal(new Date(filteredForm.ts_HandOff))
                : null,
            // ts_LocalDate: filteredForm.ts_LocalDate
            //     ? formatDateTimeLocal(new Date(filteredForm.ts_LocalDate))
            //     : null,
            PatientDOB: filteredForm.PatientDOB
                ? formatDateTimeLocal(new Date(filteredForm.PatientDOB))
                : null,
            tzCode: timeZone,
            CaseId: filteredForm.CaseId.replace(
                'FacilityCode-',
                ntspElements?.Facilities?.find((c) => c._key === filteredForm.fk_Facility)
                    ?.facilityCode + '-' || 'FacilityCode-'
            ),
            ts_RowCreated: filteredForm.ts_RowCreated ? filteredForm.ts_RowCreated :
             getNowInFacilityTimezone(form.fk_Facility, ntspElements, tzCodeToIANA),
            ts_RowUpdated: getNowInFacilityTimezone(form.fk_Facility, ntspElements, tzCodeToIANA),
            CallerPhoneNumber: filteredForm.CallerPhoneNumber
                ? filteredForm.CallerPhoneNumber.replace(/\D/g, '')
                : '',
            ts_Facilitytime: getNowInFacilityTimezone(
                filteredForm.fk_Facility,
                ntspElements,
                tzCodeToIANA
            ),
            ts_DiagnosisTime: filteredForm.ts_DiagnosisTime
                ? formatDateTimeLocal(new Date(filteredForm.ts_DiagnosisTime))
                : null,

            ts_EducationTime: filteredForm.ts_EducationTime
                ? formatDateTimeLocal(new Date(filteredForm.ts_EducationTime))
                : null,
            ts_Thrombolytic: filteredForm.ts_Thrombolytic
                ? formatDateTimeLocal(new Date(filteredForm.ts_Thrombolytic))
                : null,
            //FP-14362 fk_FollowupNeeded: !filteredForm.fk_FollowupNeeded || filteredForm.fk_FollowUps?.length > 0 ? 0 : 1
        }
        
        delete (combinedForm as { ts_LKWDate?: string }).ts_LKWDate
        delete (combinedForm as { ts_LKWTime?: string }).ts_LKWTime
        delete combinedForm.ts_EDArrivalDateOnly
        delete combinedForm.ts_EDArrivalTimeOnly

        delete (combinedForm as { ts_WakeUpStrokeDate?: string }).ts_WakeUpStrokeDate
        delete (combinedForm as { ts_WakeUpStrokeTime?: string }).ts_WakeUpStrokeTime

        let notesArray = Array.isArray(filteredForm.Notes) ? [...filteredForm.Notes] : [];
        let providerNotesArray = Array.isArray(filteredForm.ProviderNotes) ? [...filteredForm.ProviderNotes] : [];
        let hasNewNotes = false;
        // Read frontend-only flags from sourceForm — they are stripped from filteredForm
        // because initialFormState doesn't include them as enumerable keys
        const hasEditedProviderNotes = Boolean(sourceForm._providerNotesEdited);
        const isEditingExistingProviderNote = Boolean(sourceForm._providerNoteEditMode);
        const editedProviderNotesPayload = Array.isArray(sourceForm._editedProviderNotesPayload)
            ? sourceForm._editedProviderNotesPayload
            : [];

        if (hasEditedProviderNotes) {
            hasNewNotes = true;
        }

        // Get facility time zone
        const formattedDiagnosisTime =form.ts_DiagnosisTime ? moment( form.ts_DiagnosisTime)?.format('MM/DD/YYYY HH:mm') : '';
        const normalizedCurrentDiagnosisTime = normalizeToMinute(form.ts_DiagnosisTime || '');

        const formattedEducationTime = form.ts_EducationTime ? moment( form.ts_EducationTime)?.format('MM/DD/YYYY HH:mm') : '';

        if(form.flag_DiagnosisDiscussed && normalizedCurrentDiagnosisTime && savedDiagnosisTime.current !== normalizedCurrentDiagnosisTime)
        {
            const diagnosisNoteText = `Diagnosis discussed with patient at ${formattedDiagnosisTime}`
            const existingCaseDiagnosisNote = providerNotesArray
                ?.find((group) => group.CaseId === filteredForm.CaseId)
                ?.ProviderCaseNotes?.some(
                    (note) => (note.Note || '').trim() === diagnosisNoteText.trim()
                )

            if (!existingCaseDiagnosisNote) {
                hasNewNotes = true;
                const newNote = createNote({
                    caseId: filteredForm.CaseId,
                    userId,
                    userName,
                    noteText: diagnosisNoteText,
                    tzCode: filteredForm.tzCode || '',
                    noteType: 'ProviderNote',
                    ExamCompleted: false,
                    fk_CPTCodes: []
                });
                providerNotesArray = addNoteToGroups(
                    newNote,
                    providerNotesArray,        
                    filteredForm.CaseId,
                    form.fk_ConsultService,
                    form.fk_FollowUp,
                    filteredForm.ParentCaseId || null
                ); 
                    }

                    savedDiagnosisTime.current = normalizedCurrentDiagnosisTime;
        }

        if (!isEditingExistingProviderNote && filteredForm.NewNote && filteredForm.NewNote.trim() !== '') {
            hasNewNotes = true;
            const noteType: 'ProviderNote' | 'NurseNote' = activeTab === 'CaseDetails' ? 'ProviderNote' : 'NurseNote';
            if(noteType === 'ProviderNote') {
                const newNote = createNote({
                    caseId: filteredForm.CaseId,
                    userId,
                    userName,
                    noteText: filteredForm.NewNote,
                    tzCode: filteredForm.tzCode || '',
                    noteType,
                    ExamCompleted: filteredForm.ExamCompleted,
                    fk_CPTCodes: Array.isArray(filteredForm.fk_CPTCodes) ? filteredForm.fk_CPTCodes : []
                });
                providerNotesArray = addNoteToGroups(
                    newNote,
                    providerNotesArray,
                    filteredForm.CaseId,
                    form.fk_ConsultService,
                    form.fk_FollowUp,
                    filteredForm.ParentCaseId || null
                );
            } else {
                notesArray.push(
                    createNote({
                        caseId: filteredForm.CaseId,
                        userId,
                        userName,
                        noteText: filteredForm.NewNote,
                        tzCode: filteredForm.tzCode || '',
                        noteType,
                        ExamCompleted: false,
                        fk_CPTCodes: [] // Nurse notes don't use CPT codes
                    })
                );
            }
        }

        if (filteredForm.EducationNotes && filteredForm.EducationNotes.trim() !== '') {
            hasNewNotes = true;
            const newNote = createNote({
                caseId: filteredForm.CaseId,
                userId,
                userName,
                noteText: `(Patient Education) ${filteredForm.EducationNotes} and completed on ${formattedEducationTime}`,
                tzCode: filteredForm.tzCode || '',
                noteType: 'ProviderNote',
                ExamCompleted: false,
                fk_CPTCodes: []
            });
            providerNotesArray = addNoteToGroups(
                newNote,
                providerNotesArray,        
                filteredForm.CaseId,
                form.fk_ConsultService,
                form.fk_FollowUp,
                filteredForm.ParentCaseId || null
            );
            combinedForm.EducationNotes = '';
        }
        if (hasNewNotes) {
            if (hasEditedProviderNotes) {
                combinedForm.ProviderNotes =
                    editedProviderNotesPayload.length > 0
                        ? editedProviderNotesPayload
                        : providerNotesArray;
                delete (combinedForm as any).Notes;
            } else {
                if (providerNotesArray.length > 0) {
                    combinedForm.ProviderNotes = providerNotesArray;
                } else {
                    delete (combinedForm as any).ProviderNotes;
                }

                if (notesArray.length > 0) {
                    combinedForm.Notes = notesArray;
                } else {
                    delete (combinedForm as any).Notes;
                }
            }

            
            setForm((prevForm) => ({
                ...prevForm,
                Notes: notesArray,
                ProviderNotes: providerNotesArray,
                _providerNotesEdited: false,
                _providerNoteEditMode: false,
                _editedProviderNotesPayload: undefined,
            }));
        } else {
            delete (combinedForm as any).Notes;
            delete (combinedForm as any).ProviderNotes;
        }


        if ('NewNote' in combinedForm) {
            delete (combinedForm as { NewNote?: string }).NewNote;
        }
        delete (combinedForm as { _providerNotesEdited?: boolean })._providerNotesEdited;
        delete (combinedForm as { _providerNoteEditMode?: boolean })._providerNoteEditMode;
            delete (combinedForm as { _editedProviderNotesPayload?: ProviderNoteGroup[] })._editedProviderNotesPayload; //FP-14292 - Remove frontend-only property from payload

        //let notesAdded = false

        // if (filteredForm.NewNote && filteredForm.NewNote.trim() !== '') {
        //     combinedForm.Notes =
        //         (filteredForm.Notes ? filteredForm.Notes + '<br>' : '') +
        //         (userName ? ' ' + userName + ': ' : '') +
        //         filteredForm.NewNote
        //     notesAdded = true
        // }

        const data: Array<{ key: string; Value: Object }> = [
            ...Object.entries(combinedForm).map(([key, value]) => ({
                key,
                Value: value as Object,
            })),
        ]

        const payload = { FormData: data , FormGuid }
        const response = await SaveNTSPCase(payload)
        if (response && !savingError) {
            const statusCode = (response as any)?.data?.statusCode
            if (statusCode !== undefined && statusCode !== 200) {
                UnicornApp.toastr(
                    'error',
                    'Saving Case Failed: ' + 'Required fields missing or invalid'
                )
                return
            }
            // After successful save, update the form state with the new ClinicalNotes
            // Check if case was saved as "Completed"
            const savedOutcome = ntspElements?.Outcome?.find(
                (outcome) => outcome._key === filteredForm.fk_Outcome
            )
            const wasSavedAsCompleted = isCompletedOrTelephoneOutcome(
                savedOutcome?.ETLMatchValue
            )
            const currentCompletedOnLoad = Boolean((form as any)._wasCompletedOnLoad)
            dispatch(setWasCompletedOnLoad(wasSavedAsCompleted || currentCompletedOnLoad))
            
            setForm((prevForm: any) => ({
                ...prevForm,
                NewNote: '', // Clear the new note field
                ExamCompleted: false, // Clear exam completed checkbox
                fk_CPTCodes: [], // Clear CPT codes selection
                fk_FollowUps: [-1], // Reset followups to no selection
                fk_FollowupNeeded: 1, // Reset "No Follow Up Needed" to unchecked
                _wasCompletedOnLoad: wasSavedAsCompleted || prevForm._wasCompletedOnLoad, // Update if saved as completed
            }))

            initialFormRef.current = {
                ...form,
                NewNote: '',
                ExamCompleted: false,
                fk_CPTCodes: [],
                fk_FollowUps: [-1],
                fk_FollowupNeeded: 1,
                _wasCompletedOnLoad: wasSavedAsCompleted || (form as any)._wasCompletedOnLoad,
            } as any
            UnicornApp.toastr('success', 'Case Saved Successfully')
            setCaseId(filteredForm?.CaseId)
            //if (activeTab === "PatientDetails") setActiveTab('CaseDetails');
            setReload(!reload) // hacky, should revisit later - Steven
            setIsSaved(true)
            setFormGuid("guidfor_ntsp_form")
            //handleClear();
        } else if (response && !savingError) {
            initialFormRef.current = form
            UnicornApp.toastr('success', 'Case Saved Successfully')
        } else {
            UnicornApp.toastr('error', 'Saving Case Failed')
        }
    }

    // this was causing the dialog to open when clicked on close button from other tabs
    // const checkAndClear = () => {
    //     if (!isSaved && checkDirty()) {
    //         setDialogType('clear')
    //         setDialogOpen(true)
    //         return
    //     } else {
    //         handleClear()
    //     }
    // }

    const handleClear = () => {
        // close the current form
        setForm(initialFormState)
        initialFormRef.current = initialFormState
        setCaseId(undefined)
        setTempId('')
        setActiveTab('PatientDetails')
        setErrors({})
        setIsSaved(false)
    }

    useEffect(() => {
        renderForm(form)
    }, [activeTab])

    useEffect(() => {
        let timer: NodeJS.Timeout | undefined
        if (form.fk_Facility !== -1) {
            const selectedFacility = ntspElements?.Facilities?.find(
                (f) => f._key === form.fk_Facility
            )
            const ianaTz = selectedFacility?.TZCode
                ? tzCodeToIANA(selectedFacility.TZCode)
                : undefined
            const updateTime = () => {
                if (ianaTz) {
                    setFacilityTime(moment.tz(new Date(), ianaTz).format('HHmm'))
                } else {
                    setFacilityTime('')
                }
            }
            updateTime()
            timer = setInterval(updateTime, 1000)
        } else {
            setFacilityTime('')
        }
        return () => {
            if (timer) clearInterval(timer)
        }
    }, [form.fk_Facility])

    const handleFacilityOCVClick = (Facility: number) => {
        const FacilityFetcherProcId = ntspElements?.FacilityFetcherProcId
        
        if (!FacilityFetcherProcId) {
            console.error('FacilityFetcherProcId not available')
            return
        }

        const facility = ntspElements?.Facilities?.find((c) => c._key === Facility)
        const facilityName = facility?.FriendlyName || ''
        
        try {
            openOCVDialog(
                FacilityFetcherProcId,
                Facility,
                'NTSPFacilityObjectFetcher',
                `${facilityName} Contact Details`
            )
        } catch (error) {
            console.error('Error opening facility details:', error)
        }
    }

    const renderForm = (form: ApiDTO_NTSPform) => {
        if (isLoadingNTSPElements){ 
            return <span className="ntsp-form-container"><div id='ajax-loading-box-attr' className ="ajax-loading-box show"><span
                className="ajax-loading-image"></span>
                Loading...
            </div></span>
        }
        switch (activeTab) {
            case 'PatientDetails':
                return (
                    <PatientDetails
                        form={form}
                        setForm={setForm}
                        NTSPElements={ntspElements}
                        handleSave={handleSave}
                        handleClear={handleClear}
                        newCase={newCase}
                        handleTabSwitch={handleTabSwitch}
                        validationSchema={PatientDetailsvalidationSchema}
                        errors={errors}
                        setErrors={setErrors}
                        isSaved={isSaved}
                        nurseNotes={nurseNotes as DTO_NTSPCaseNote[]}
                        isLoadingNTSPElements={isLoadingNTSPElements}
                        selectedSymptoms={selectedSymptoms}
                        setSelectedSymptoms={setSelectedSymptoms}
                    />
                )
            case 'CaseDetails':
                return (
                    <CaseDetails
                        form={form}
                        setForm={setForm}
                        NTSPElements={ntspElements}
                        handleSave={handleSave}
                        handleClear={handleClear}
                        handleTabSwitch={handleTabSwitch}
                        validationSchema={FullValidationSchema}
                        errors={errors}
                        setErrors={setErrors}
                        isSaved={isSaved}
                        providerNotes={providerNotes as ProviderNoteGroup[]}
                        nurseNotes={nurseNotes}
                        selectedSymptoms={selectedSymptoms}
                        setSelectedSymptoms={setSelectedSymptoms}
                        currentUserId={UnicornApp.globals?.me.get('id') || -1}
                    />
                )
            // case 'NurseNotes':
            //     return (
            //         <NurseNotes
            //             form={form}
            //             setForm={setForm}
            //             NTSPElements={ntspElements}
            //             handleSave={handleSave}
            //             handleClear={checkAndClear}
            //             handleTabSwitch={handleTabSwitch}
            //             validationSchema={ClinicalvalidationSchema}
            //             errors={errors}
            //             setErrors={setErrors}
            //             isSaved={isSaved}
            //             nurseNotes={nurseNotes}
            //         />
            //     )
            case 'Summary':
                return (
                    <Summary
                        form={form}
                        setForm={setForm}
                        handleTabSwitch={handleTabSwitch}
                        NTSPElements={ntspElements}
                        handleSave={handleSave}
                        handleClear={handleClear}
                        validationSchema={FullValidationSchema}
                        isSaved={isSaved}
                        nurseNotes={nurseNotes}
                        errors={errors}
                        setErrors={setErrors}
                    />
                )
            case 'Comments':
                return (
                    <Comments
                        form={form}
                        setForm={setForm}
                        handleTabSwitch={handleTabSwitch}
                        NTSPElements={ntspElements}
                        handleSave={handleSave}
                        validationSchema={FullValidationSchema}
                        handleClear={handleClear}
                        isSaved={isSaved}
                        errors={errors}
                        setErrors={setErrors}
                    />
                )
            case 'PatientEducation':
                return (
                    <PatientEducation
                        form={form}
                        setForm={setForm}
                        errors={errors}
                        setErrors={setErrors}
                        handleTabSwitch={handleTabSwitch}
                        NTSPElements={ntspElements}
                        handleSave={handleSave}
                        handleClear={handleClear}
                        validationSchema={FullValidationSchema}
                        isSaved={isSaved}
                        providerNotes={providerNotes as ProviderNoteGroup[]}
                    />
                )
                case 'CaseLink':
                return (
                    <CaseLink
                        form={form}
                        setForm={setForm}
                        handleTabSwitch={handleTabSwitch}
                        handleSave={handleSave}
                        isSaved={isSaved}
                    />
                )
            case 'ProcessIssues':  //FP-14209 - NTSP Stat Portal - Process Issues Tab Component
                return (
                    <ProcessIssues
                        form={form}
                        setForm={setForm}
                        handleTabSwitch={handleTabSwitch}
                        handleSave={handleSave}
                        NTSPElements={ntspElements}
                        isSaved={isSaved}
                        handleClear={handleClear}
                        validationSchema={ProcessIssuesValidationSchema}
                        errors={errors}
                        setErrors={setErrors}
                    />
                )
            case 'PostMRSTracking': // FP-14213: Post MRS Tracking Tab Component
                return (
                    <PostMRSTracking
                        form={form}
                        NTSPElements={ntspElements}
                        errors={errors}
                        setErrors={setErrors}
                        validationSchema={{
                            ...PostMRSValidationSchema,
                            ...PatientDetailsvalidationSchema,  // FP-14213: Adding PatientDetailsvalidationSchema to Post MRS Tracking tab
                            ...ClinicalvalidationSchema,  // FP-14213: Adding ClinicalvalidationSchema to Post MRS Tracking tab
                        }}
                        setForm={setForm}
                        handleTabSwitch={handleTabSwitch}
                        handleSave={handleSave}
                        handleClear={handleClear}   // FP-14213: Adding handleClear to Post MRS Tracking tab
                        isSaved={isSaved}
                    />
                )
            default:
                return null
        }
    }
    // border-bottom: 1px solid rgb(75 75 75);
    return (
        <span ref={formRef}>
            <UnsavedChangesGuard isDirty={isdirty} formData={form} setFormData={setForm} />
            <div className="tab_section">
                <span className="ntsp_tab-buttons w-100">
                    <button
                        id="ntsp_tab_PatientDetails"
                        title="Patient Details"
                        className={`py-3 ntsp_tab-button ${activeTab === 'PatientDetails' ? 'active' : ''}`}
                        onClick={() => setActiveTab('PatientDetails')}
                    >
                        1. Patient Details
                    </button>
                    {!isCustomerSite && (
                        <button
                            id="ntsp_tab_casedetails"
                            title={!form.CaseId ? 'Create or select case to view details' : 'Provider Case Data'}
                            disabled={!form.CaseId}
                            className={`py-3 ntsp_tab-button ${activeTab === 'CaseDetails' ? 'active' : ''}`}
                            onClick={() => setActiveTab('CaseDetails')}
                        >
                            2. Provider Case Data
                        </button>
                    )}
                    {!isCustomerSite && (
                    <button
                        id="ntsp_tab_Comments"
                        title={!form.CaseId ? 'Create or select case to view details' : 'History'}
                        disabled={!form.CaseId}
                        className={`py-3 ntsp_tab-button ${activeTab === 'Comments' ? 'active' : ''}`}
                        onClick={() => setActiveTab('Comments')}
                    >
                        3. History
                    </button>
                    )}
                    {!isCustomerSite && (
                    <button
                        id="ntsp_tab_summary"
                        title={!form.CaseId ? 'Create or select case to view details' : 'Summary'}
                        disabled={!form.CaseId}
                        className={`py-3 ntsp_tab-button ${activeTab === 'Summary' ? 'active' : ''}`}
                        onClick={() => setActiveTab('Summary')}
                    >
                        4. Summary
                    </button>
                    )}
                    {!isCustomerSite && isPatientEducationFollowUp(ntspElements, form.fk_FollowUp) && (
                        <button
                            id="ntsp_tab_PatientEducation"
                            title={
                                !form.CaseId
                                    ? 'Create or select case to view details'
                                    : 'Patient Education'
                            }
                            disabled={!form.CaseId}
                            className={`py-3 ntsp_tab-button ${activeTab === 'PatientEducation' ? 'active' : ''}`}
                            onClick={() => setActiveTab('PatientEducation')}
                        >
                            5. Patient Education
                        </button>
                    )}
                    {!isCustomerSite && (
                     <button
                        id="ntsp_tab_caselink"
                        title={!form.CaseId ? 'Create or select case first' : 'Link / Merge Cases'}
                        disabled={!form.CaseId}
                        className={`py-3 ntsp_tab-button ${activeTab === 'CaseLink' ? 'active' : ''}`}
                        onClick={() => setActiveTab('CaseLink')}
                    >
                        {isPatientEducationFollowUp(ntspElements, form.fk_FollowUp) ? '6' : '5'}. Case Link
                    </button>
                    )}
                    {!isCustomerSite && (
                     <button
                        id="ntsp_tab_PostMRSTracking"
                        title={!form.CaseId ? 'Create or select case to view details' : 'Post MRS Tracking'}
                        disabled={!form.CaseId}
                        className={`py-3 ntsp_tab-button ${activeTab === 'PostMRSTracking' ? 'active' : ''}`}
                        onClick={() => setActiveTab('PostMRSTracking')}
                    >
                        {isPatientEducationFollowUp(ntspElements, form.fk_FollowUp) ? '7' : '6'}. Post MRS Tracking
                    </button>
                    )}
                     {!isCustomerSite && ( // FP-14209 - NTSP Stat Portal - Process Issues Tab Component - hide Process Issues tab for customer site as per requirement
                     <button
                        id="ntsp_tab_processIssue"
                        title={!form.CaseId ? 'Create or select case first' : 'Process Issues'}
                        disabled={!form.CaseId}
                        className={`py-3 ntsp_tab-button ${activeTab === 'ProcessIssues' ? 'active' : ''}`}
                        onClick={() => setActiveTab('ProcessIssues')}
                    >
                        {isPatientEducationFollowUp(ntspElements, form.fk_FollowUp) ? '8' : '7'}. Process Issues
                    </button>  
                     )} {/* FP-14209*/}
                </span>
                {!!form.CaseId && (
                    <>
                        <span className={form.fk_Facility === -1 ? 'hide' : 'info_section'}>
                            <h6
                                className="my-3"
                                style={{ display: 'flex', alignItems: 'center', color: '#00ae00' }}
                            >
                                <a style={{ whiteSpace: 'nowrap', color: '#00ae00' }} href="#" onClick={(e) => { e.preventDefault(); handleFacilityOCVClick(form.fk_Facility); }}>
                                    {
                                        (() => {
                                            const facility = ntspElements?.Facilities?.find(
                                                (c) => c._key === form.fk_Facility
                                            );
                                            const facilityName = facility?.FriendlyName || '';
                                            const ianaTz = facility?.TZCode ? tzCodeToIANA(facility.TZCode) : '';
                                            const now = ianaTz ? moment.tz(new Date(), ianaTz) : moment(new Date());
                                            const tzAbbr = ianaTz ? now.format('z') : '';
                                            const timeStr = now.format('HH:mm');
                                            return `${facilityName}${timeStr && tzAbbr ? ` (${timeStr} ${tzAbbr})` : ''}`;
                                        })()
                                    }
                                </a>
                            </h6>
                        </span>
                        <span className={form.fk_FollowUp !== -1 ? 'hide' : ''}>
                            <h6 className="my-3" style={{ display: 'flex', alignItems: 'center' }}>
                                <span
                                    className="deemphasize-header ml-3"
                                    style={{ marginRight: 4, whiteSpace: 'nowrap' }}
                                >
                                    Service line :
                                </span>
                                <span style={{ whiteSpace: 'nowrap' }}>
                                    {ntspElements?.ConsultServices?.find(
                                        (c) => c._key === form.fk_ConsultService
                                    )?.FriendlyName || 'Unknown'}
                                </span>
                            </h6>
                        </span>
                        <span className={form.fk_FollowUp !== -1 ? '' : 'hide'}>
                            <h6 className="my-3" style={{ display: 'flex', alignItems: 'center' }}>
                                <span className='ml-3' style={{ whiteSpace: 'nowrap' }}>
                                    {ntspElements?.FollowUp?.find(
                                        (c) => c._key === form.fk_FollowUp
                                    )?.FriendlyName || 'Unknown'}
                                </span>
                            </h6>
                        </span>
                        <span style={{ display: 'inline-block', marginRight: 20 }}>
                            <h6 className="my-3" style={{ display: 'flex', alignItems: 'center' }}>
                                <span
                                    className="deemphasize-header ml-3"
                                    style={{ marginRight: 4, whiteSpace: 'nowrap' }}
                                >
                                    Status :
                                </span>
                                <span style={{ whiteSpace: 'nowrap' }}>
                                    {form.fk_Outcome === -1
                                        ? 'Pending'
                                        :
                                    ntspElements?.Outcome?.find((c) => c._key === form.fk_Outcome)
                                        ?.FriendlyName || 'Unknown'}
                                    
                                </span>
                            </h6>
                        </span>
                    </>
                )}
                {/* <span><h6 style={{ marginBottom: '20px' }}><span className="deemphasize-header ml-3">Service line :</span> {ntspElements?.ConsultServices?.find(c => c._key === form.fk_ConsultService)?.FriendlyName || "N/A"}</h6></span>
                    <span><h6 style={{ marginBottom: '20px' }}><span className="deemphasize-header ml-3">Status :</span> {ntspElements?.ConsultServices?.find(c => c._key === form.fk_ConsultService)?.FriendlyName || "N/A"}</h6></span> */}
            </div>
            {renderForm(form)}

            <Dialog
                isOpen={dialogOpen}
                title="There are unsaved changes"
                width={300}
                minHeight={130}//FP-14498: Adjusted dialog height to better fit new button labels and confirmation message
                className="ui-front ui-dialog-buttons left-align-text"
                buttons={[
                    {
                        label: 'Discard', //FP-14498: rename "Yes" button to "Discard" for better clarity on action being taken
                        className: 'ui-button ui-corner-all ui-widget app-button',
                        onClick: handleDialogConfirm,
                    },
                    {
                        label: 'Keep Editing',
                        className: 'ui-button ui-corner-all ui-widget app-button',
                        onClick:  handleDialogCancel,
                    },//FP-14498: rename "No" button to "Keep Editing" and "Yes" button to "Discard" for better clarity on action being taken
                ]}
                hideClose={true}
            >
                Discard unsaved changes? {/* FP-14498: rename confirmation message */}
            </Dialog>
        </span>
    )
}

export default NTSP_StatPortal
